/**
 * PackagesCtrl controller
 * Show all packages
 */

/**
 * PackagesCtrl controller
 *
 * @class PackagesCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:PackagesCtrl
 */
/* @ngInject */
export default function PackagesCtrl ($scope, $location, historySvc, Network, inapp) {
  var vm = this

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true
  vm.loading = true

  /**
   * Default Package for in-app registration
   *
   * @memberof mwApp/packages.controller:PackagesCtrl
   * @type {number}
   */
  vm.inappNetworkId = !inapp?.multiorgEnabled && inapp?.inAppRegistrationSettings?.enabled && inapp.inAppRegistrationSettings.network?.id

  /**
   * Default Package for Guest Mode
   *
   * @memberof mwApp/packages.controller:PackagesCtrl
   * @type {number}
   */
  vm.guestNetworkId = !inapp?.multiorgEnabled && inapp?.guestModeSettings?.enabled && inapp.guestModeSettings.network?.id

  /**
   * Object with search strings
   *
   * @memberof mwApp/packages.controller:PackagesCtrl
   * @type {Object}
   */
  vm.searchStrInPackage = {}

  /**
   * Search subscribers in package
   *
   * @memberof mwApp/packages.controller:PackagesCtrl
   * @function
   * @param  {Number} id - network id
   */
  vm.searchIn = id => {
    if (id && vm.searchStrInPackage[id]) {
      $location.url('subscribers?networks=' + id + '&q=' + vm.searchStrInPackage[id])
    }
  }

  /**
   * Flag, indicating that there are networks to show
   *
   * @memberof mwApp/packages.controller:PackagesCtrl
   * @type {Boolean}
   */
  vm.hasNetworks = true

  /**
   * DataSource for "infinite" scrolling
   *
   * @memberof mwApp/packages.controller:PackagesCtrl
   * @type {Object}
   */
  vm.networksData = {
    get: function (index, count, success) {
      var result = []
      vm.hasNetworks = vm.networks.length > 0
      if (vm.hasNetworks) {
        for (var i = index; i <= index + count - 1; i++) {
          if (vm.networks[i]) {
            result.push(vm.networks[i])
          }
        }
      }
      success(result)
    }
  }

  // set initial filter value
  vm.filterByName = $location.search().q

  /**
   * Filter networks by name
   *
   * @memberof mwApp/packages.controller:PackagesCtrl
   * @param  {String} name - network name
   */
  vm.filterBy = function (name) {
    // set q to navigation bar
    $location.search('q', name || null)

    // save history state
    historySvc.push()

    vm.networks = name
      ? vm.allNetworks.filter(n => n.name.toLowerCase().indexOf(name.toLowerCase()) !== -1)
      : vm.allNetworks
    vm.networksAdapter.reload()
  }

  // load all packages
  Network.loadAll('?count=true')
    .to(vm.networks = vm.allNetworks = [])
    .then(
      () => {
        // Handle open/collapse events of Accordion
        // https://stackoverflow.com/questions/15642082/handle-open-collapse-events-of-accordion-in-angular
        vm.networks.forEach(
          network => {
            var isOpened = false
            Object.defineProperty(network, 'open', {
              get () { return isOpened },
              set (newValue) {
                isOpened = newValue
                if (isOpened) {
                  network._loadInfo()
                }
              }
            })
          }
        )

        vm.filterBy(vm.filterByName)
        $scope.loading = false
        vm.loading = false
      }
    )

  /**
   * Check network's platform
   *
   * @function
   * @memberof mwApp/packages.controller:PackagesCtrl
   * @param  {String} platform - platform name
   * @return {Boolean}
   */
  vm.hasPlatform = (platform) => (network) =>
    network.platforms &&
    network.platforms.length &&
    network.platforms.indexOf(platform) !== -1

  /**
   * Check, if network has STB platform
   *
   * @function
   * @memberof mwApp/packages.controller:PackagesCtrl
   * @param  {models.Network} network
   * @return {Boolean}
   */
  vm.hasSTB = vm.hasPlatform('STB')

  // TODO fix: ng-disabled has no affect to <a>, so, vm.hasSTB is useless
}
